import { render, staticRenderFns } from "./VehicleEquipment.vue?vue&type=template&id=0fbd1484&"
import script from "./VehicleEquipment.vue?vue&type=script&lang=js&"
export * from "./VehicleEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports